import React, { useState, useEffect } from "react";
import Icon from "../../../common/components/Icon";
import { getUserInfo } from "../../../api/usercall";
import { getPromotionPackages } from "../../../api/getPromotionPackages";
import infoIcon from '../../../assets/icons/info.svg';
import doneIcon from '../../../assets/icons/done.svg';
import { t } from "i18next";
import i18n from "../../../language/i18n";

function BuyPackage({ setActiveTab }) {
    const [userInfo, setUserInfo] = useState(null);
    const [promotionPackages, setPromotionPackages] = useState([]);
    const [isLoadingPackages, setIsLoadingPackages] = useState(true);

    const getApiLanguageCode = () => {
        const currentLang = i18n.language || 'kz';
        return currentLang === 'kz' ? 'kk' : currentLang;
    };

    const getLocalizedField = (packageItem, fieldName) => {
        const lang = getApiLanguageCode();
        const fieldKey = `${fieldName}_${lang}`;
        return packageItem[fieldKey] || packageItem[fieldName] || '';
    };

    useEffect(() => {
        const fetchUserInfo = async () => {
            try {
                const data = await getUserInfo();
                setUserInfo(data.user);
            } catch (err) {}
        };
        fetchUserInfo();
    }, []);

    useEffect(() => {
        const fetchPromotionPackages = async () => {
            setIsLoadingPackages(true);
            try {
                const packages = await getPromotionPackages();
                const activePackages = packages.filter(pkg => pkg.is_active);
                setPromotionPackages(activePackages);
            } catch (error) {
                setPromotionPackages([]);
            } finally {
                setIsLoadingPackages(false);
            }
        };
        fetchPromotionPackages();
    }, []);

    const handleBackClick = () => {
        setActiveTab(null);
    };

    return (
        <div className="p-4">
            <Icon src="backicon" onClick={handleBackClick} className="mb-4" />

            <h2 className="text-xl font-semibold mb-4">{t('buyPackage')}</h2>

            <div className="bg-white p-4 rounded-xl shadow mb-4">
                <p className="mb-2">
                    {t('yourBalance')}: 
                    <span className="font-bold ml-2">
                        {userInfo?.balance} {t('units')}
                    </span>
                </p>

                <div className="flex items-start gap-2 text-sm text-gray-500">
                    <img src={infoIcon} alt="info" className="w-4 h-4" />
                    <p>{t('rule_unit')}</p>
                </div>
            </div>

            <div className="flex flex-col md:flex-row gap-4">
                {isLoadingPackages ? (
                    <div className="w-full text-center p-6 bg-gray-100 rounded-lg">
                        {t('loading') || 'Жүктелуде...'}
                    </div>
                ) : promotionPackages.length === 0 ? (
                    <div className="w-full text-center p-6 bg-gray-100 rounded-lg">
                        {t('noData') || 'Деректер жоқ'}
                    </div>
                ) : (
                    promotionPackages.map((packageItem) => {
                        const hasError = userInfo?.balance < packageItem.units;

                        const pkg = {
                            id: packageItem.id,
                            title: getLocalizedField(packageItem, 'title'),
                            duration: getLocalizedField(packageItem, 'duration_description'),
                            units: packageItem.units,
                            price: `${packageItem.price} ${packageItem.currency || 'тг.'}`,
                            active: false,
                            error: hasError,
                        };

                        return (
                            <div
                                key={pkg.id}
                                className="flex-1 bg-white p-4 rounded-xl shadow flex flex-col justify-between"
                            >
                                <div>
                                    <h3 className="text-lg font-semibold mb-2">
                                        {pkg.title}
                                    </h3>

                                    <div className="flex items-center gap-2 mb-2">
                                        <img src={doneIcon} alt="done" className="w-4 h-4" />
                                        <p className="text-sm">{pkg.duration}</p>
                                    </div>

                                    <div className="flex items-center gap-2 mb-2">
                                        <img src={doneIcon} alt="done" className="w-4 h-4" />
                                        <p className="text-sm">
                                            {t('units')}: {pkg.units}
                                        </p>
                                    </div>

                                    <div className="flex items-center gap-2 mb-4">
                                        <img src={doneIcon} alt="done" className="w-4 h-4" />
                                        <p className="text-sm">
                                            {t('price') || 'Стоимость'}: {pkg.price}
                                        </p>
                                    </div>
                                </div>

                                <div>
                                    {pkg.error && (
                                        <div className="flex items-start gap-2 text-red-500 text-sm mb-3">
                                            <img src={infoIcon} alt="info" className="w-4 h-4" />
                                            <p>
                                                {t('notEnoughCredits') || 'На вашем счете недостаточно'} {t('units')}, {t('needTo') || 'необходимо'}{' '}
                                                <a href="/profile#walletTopUp" className="underline">
                                                    {t('topupBalance') || 'пополнить баланс'}
                                                </a>
                                            </p>
                                        </div>
                                    )}

                                    <button
                                        disabled={pkg.error}
                                        className={`w-full py-2 rounded-lg text-white transition ${pkg.error
                                            ? 'bg-gray-400 cursor-not-allowed'
                                            : 'bg-[#147F26] hover:bg-[#0f5f1a]'
                                        }`}
                                    >
                                        {pkg.active
                                            ? (t('activated') || 'Активирован')
                                            : (t('activate') || 'Активировать')}
                                    </button>
                                </div>
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
}

export default BuyPackage;
